"use strict";

function logUserEvent(event) {
    var sessionId = document.cookie.match(/PHPSESSID=[^;]+/).toString().replace("PHPSESSID=", "");
    var searchValue = window.SearchBenefits.postcode == '' ? window.SearchBenefits.suburbName : window.SearchBenefits.postcode;
    var currentStation = jQuery('.stations.active').text().toString().replace("Station", " Station");
    var currentLine = jQuery('.lines.active a').attr("data-line");
    if (currentLine == undefined && jQuery('.lines.active').attr('class') != undefined) {
        currentLine = jQuery('.lines.active').attr('class').replace("col-xs-2 lines ", "").toString().replace("active", "").toString().replace("-", " ");
    } else if (jQuery('.lines.active').attr('class') == undefined) {
        currentLine = '';
    }
    var currentTab = jQuery('.accordion-toggle[aria-expanded=true]').text().replace("-", "  ");
    //console.log( " \n Session:" + sessionId , " \n \n Event:" + event , "\n\n Search Value:" + searchValue, "\n Station:" + currentStation , "\n Line:" + currentLine , "\n Tab:" + currentTab );
    var data = { "currentAction": event, "sessionId": sessionId, "searchValue": searchValue, "currentStation": currentStation, "currentLine": currentLine, "currentTab": currentTab };
    var check_mate = '';
    if (document.cookie.match(/checkmate_uact=[^;]+/) != undefined) {
        check_mate = document.cookie.match(/checkmate_uact=[^;]+/).toString().replace("checkmate_uact=", "");
    }

    fetch(window.location.origin + '/API/uact', {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            "X-Requested-With": "XMLHttpRequest",
            "X-CSRF-Token": check_mate
        },
        method: "POST",
        body: JSON.stringify({ data: data })
    });
    // .then(response => {
    //     return response.text().then(function (text) {
    //         return text ? JSON.parse(text) : {}
    //     })
    // })
    // .then(precinctResultList => {
    //     this.setState({precinctResultList});
    // };
}

/*
 * jQuery css bezier animation support -- Jonah Fox
 * version 0.0.1
 * Released under the MIT license.
 */

(function ($) {

    $(document).ready(function () {
        //accordion hide/show fix
        var $accordion = $('#accordion');
        $accordion.on('show.bs.collapse', '.collapse', function () {
            $accordion.find('.collapse.in').collapse('hide');
        }).on('shown.bs.collapse', function () {
            logUserEvent('tab_click');
        });

        //modals show/hide
        $(".modal-trigger-stations").click(function (e) {
            e.preventDefault();
            $("#modal-info-stations").modal('show');
            logUserEvent('about_stations_click');
        });

        $(".modal-trigger-about-data").click(function (e) {
            e.preventDefault();
            $("#modal-info-about-data").modal('show');
            logUserEvent('about_this_data_click');
        });

        $("#modal-info-stations .modal-header button.close").click(function (e) {
            $('.modal-trigger-stations').focus();
        });

        $("#modal-info-about-data .modal-header button.close").click(function (e) {
            $('.modal-trigger-about-data').focus();
        });

        var $stationModal = $("#modal-info-stations"),
            $stationModalClose = $(".modal-header button");

        $stationModal.on("shown.bs.modal", function () {
            document.activeElement.blur();
            $stationModalClose.focus();
        });

        var $infDataModal = $("#modal-info-about-data"),
            $infDataModalClose = $(".modal-header button");

        $infDataModal.on("shown.bs.modal", function () {
            document.activeElement.blur();
            $infDataModalClose.focus();
        });
    });
})(jQuery); // End of use strict